import React from 'react';
import Button from '../components/ui/Button.jsx';
import { apiFetch } from '../api.js';

export default function LoginStaff() {
  const [loading, setLoading] = React.useState(false);
  const [authError, setAuthError] = React.useState('');
  const [localError, setLocalError] = React.useState('');
  const [localEnabled, setLocalEnabled] = React.useState(false);
  const [localUsername, setLocalUsername] = React.useState('');
  const [localPassword, setLocalPassword] = React.useState('');
  const [localLoading, setLocalLoading] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('error');
    const email = params.get('email');
    const detail = params.get('detail');
    if (!code) return;
    const message = {
      not_found_admin: 'We could not match your advisor account. Please verify your email exists in the admin table (username or email).',
      invalid_request: 'Login request was incomplete. Please try again.',
      invalid_state: 'Login session expired. Please try again.',
      session_failed: 'Session could not be created. Please contact support.',
      auth_failed: 'Authentication failed. Please try again.'
    }[code] || 'Login failed. Please contact support.';
    let finalMessage = email ? `${message} (${email})` : message;
    if (detail) {
      finalMessage += ` — ${detail}`;
    }
    setAuthError(finalMessage);
  }, []);

  React.useEffect(() => {
    fetch('/api/auth/local/status', { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => setLocalEnabled(!!data?.enabled))
      .catch(() => {});
  }, []);

  const startLogin = async () => {
    setLoading(true);
    setAuthError('');
    setLocalError('');
    try {
      const res = await fetch('/api/auth/entra/url?role=admin', { credentials: 'include' });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error?.message || 'Login failed');
      window.location.href = data.url;
    } catch (err) {
      setAuthError(err.message);
      setLoading(false);
    }
  };

  const startLocalLogin = async () => {
    setLocalLoading(true);
    setAuthError('');
    setLocalError('');
    try {
      const data = await apiFetch('/api/auth/local/login', {
        method: 'POST',
        body: JSON.stringify({
          role: 'admin',
          username: localUsername,
          password: localPassword
        })
      });
      if (data?.redirect) {
        window.location.href = data.redirect;
      }
    } catch (err) {
      setLocalError(err.message);
      setLocalLoading(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-card">
        <h1>Advisor Login</h1>
        <p>Sign in with your Cal State LA credentials using Microsoft Entra.</p>
        {authError ? <div className="alert error">{authError}</div> : null}
        <Button onClick={startLogin} disabled={loading}>
          {loading ? 'Redirecting...' : 'Continue with SSO'}
        </Button>
        {localEnabled ? (
          <>
            <div className="auth-divider" />
            <form
              className="auth-local"
              onSubmit={(event) => {
                event.preventDefault();
                if (!localLoading && localUsername && localPassword) {
                  startLocalLogin();
                }
              }}
            >
              <div className="auth-local-title">Local login (dev only)</div>
              {localError ? <div className="alert error">{localError}</div> : null}
              <div className="input-field">
                <label className="input-label" htmlFor="local-admin-username">Username</label>
                <input
                  id="local-admin-username"
                  className="input"
                  type="text"
                  autoComplete="username"
                  value={localUsername}
                  onChange={(event) => setLocalUsername(event.target.value)}
                />
              </div>
              <div className="input-field">
                <label className="input-label" htmlFor="local-admin-password">Password</label>
                <input
                  id="local-admin-password"
                  className="input"
                  type="password"
                  autoComplete="current-password"
                  value={localPassword}
                  onChange={(event) => setLocalPassword(event.target.value)}
                />
              </div>
              <Button variant="secondary" type="submit" disabled={localLoading || !localUsername || !localPassword}>
                {localLoading ? 'Signing in...' : 'Login Locally'}
              </Button>
            </form>
          </>
        ) : null}
      </div>
    </div>
  );
}
